/*eslint-disable */

import Vue from 'vue';
import Vuex from 'vuex';
import { gsap }  from 'gsap';
import { CSSPlugin }  from 'gsap/all';

import {fbase } from '../main.js';
gsap.registerPlugin(CSSPlugin)

Vue.use(Vuex);
export const  store = new Vuex.Store({
    state: {
        userFingerprintHash: false,
        userFingerprintObj: false,
        userName : false,
        userEmail : false,
        userSpecialization: false,
        currentQuestion : false, // вопрос, отображаемый в данный момент
        hasFinished : false, // флаг, указывающий на то, что опрос завершен
        questions: false,
        resultMarks: false,
        timer: false,
        timerValue: 0,
        finalText: false,
        startText: '',
        initImg: false,
        initImgDesc: '',
        inviteText: '',
        startButtonText: 'Начать',
        nextQuestionButtonText: 'Следующий вопрос',
        resultsButtonText: 'Результаты',
        quizName: ''
    },
    getters: {
        //Набор методов позаоляющий полочить доступ к любым частям состояния
        name : function (state) {
            // may do something
            // console.log('some never runned getter ');
            return state.key;
        },
        currentQuestion : function (state) {
            return state.currentQuestion;
        },
        currentQuestionObject : function (state) {
            if ( state.currentQuestion <= 0 || state.currentQuestion > state.questions.length)
                return false;

            return state.questions[(state.currentQuestion - 1)];
        },
        questionsAmount : function(state) {
            return state.questions.length;
        },
        selectedVariantOfQuestion : function (state) {
            return function (data) {
                for (var k = 0; k < state.questions.length; k++) {
                    if ( state.questions[k].key == data.qKey ) {
                        return state.questions[k].selectedVariant;
                    }
                }
                return false;
            }
        },
        isFinished : function ( state ) {
            return state.hasFinished;
        },
        resultMark : function (state) {
            return function (correctAnswersNumber) {
                if (correctAnswersNumber < 0 || correctAnswersNumber > state.questions.length)
                    return '';

                return state.resultMarks[correctAnswersNumber].text;
            }
        },
        results : function (state) {
            var questions = [];
            var correctAnswers = 0;

            for ( var k = 0; k < state.questions.length; k++ ) {
                var q = state.questions[k];
                if (q.correctAnswer == q.selectedVariant) {
                    correctAnswers++;
                }
                var cA = q.variants.filter(function(elem) {return elem.key == q.correctAnswer});
                var uA = q.variants.filter(function(elem) {return elem.key == q.selectedVariant});

                questions.push({
                    text : q.title,
                    correctAnswer : cA.length > 0 ?  cA[0].text : false,
                    userAnswered : uA.length > 0 ? uA[0].text : false,
                    isCorrect : q.correctAnswer == q.selectedVariant,
                });
            }
            var result = {
                userBrowserFingerprintHash : state.userFingerprintHash,
                userBrowserFingerprintData : state.userFingerprintObj,
                totalQuestionsAmount : state.questions.length,
                answeredQuestionsAmount : state.currentQuestion,
                correctAnswersAmount : correctAnswers,
                incorrectAnswersAmount : state.currentQuestion - correctAnswers,
                email : state.userEmail,
                name : state.userName,
                specialization: state.userSpecialization,
                questions : questions,
                timestamp : Date.now(),
                amountOfSecondsTook: state.timerValue,
            };
            return result;
        },
        userName : function ( state ) {
            return state.userName;
        },
        userEmail : function ( state ) {
            return state.userEmail;
        },
        finalText: function ( state ) {
            return state.finalText;
        },
        initData: function ( state ) {
            var data = {
              finalText: state.finalText,
              initImg: state.initImg,
              initImgDesc: state.initImgDesc,
              inviteText: state.inviteText,
              nextQuestionButtonText: state.nextQuestionButtonText,
              questions: state.questions,
              quizName: state.quizName,
              resultMarks: state.resultMarks,
              resultsButtonText: state.resultsButtonText,
              startButtonText: state.startButtonText,
              startText: state.startText,
            };
            return data;
        },
        initImg: function ( state ) {
            return state.initImg;
        },
        inviteText: function ( state ) {
            return state.inviteText;
        }
    },
    mutations: {
        // Набор методов для изменения любых частей состояния приложения.
        // Вызываются в компонентах в computed свойствах так: this.$store
        name : function (state, nameStr) {
         //    do something with some part of state
         //    nothing returns, just change
            state.userName = nameStr;
        },
        email : function (state, emailStr) {
            state.userEmail = emailStr;
        },
        specialization : function (state, specialization) {
            state.userSpecialization = specialization;
        },
        nextQuestion : function(state) {
            var questionsAmount = state.questions.length;
            if ( state.currentQuestion < questionsAmount ) {
                state.currentQuestion ++;
                const el = document.querySelectorAll('.question');
                if (el.length > 0) {
                    // el.style.opacity = 0;
                    gsap.to(el, 0.4, {opacity: 1, y: 0 });
                }

            } else {
                state.hasFinished = true;
                clearInterval(state.timer);
            }
        },
        prevQuestion : function (state) {
            if ( state.currentQuestion > 0 ) {
                state.currentQuestion --;
            }
        },
        setAnswer : function(state, data) {
            for (var k = 0; k < state.questions.length; k++) {
                if ( state.questions[k].key == data.qKey ) {
                    state.questions[k].selectedVariant = data.selectedVariant;
                    break;
                }
            }
        },
        setFingerprintHash : function (state, data) {
            state.userFingerprintHash = data;
        },
        setFingerprintObj : function(state, data) {
            state.userFingerprintObj = data;
        },
        initStart : function (state) {
            state.hasFinished = false;
            state.currentQuestion = false;
            for (var k = 0; k < state.questions.length; k++) {
                state.questions[k].selectedVariant = false;
            }
        },
        setInitialData : function (state, initData) {
            state.finalText = initData.finalText ? initData.finalText : false;
            state.questions = initData.questions ? initData.questions : false;
            state.resultMarks = initData.resultMarks ? initData.resultMarks : false;
            state.startText = initData.startText ? initData.startText : false;
            state.initImg =  initData.initImg ? initData.initImg : false;
            state.inviteText =  initData.inviteText ? initData.inviteText : '';
            state.startButtonText = initData.startButtonText ? initData.startButtonText : 'Начать';
            state.nextQuestionButtonText = initData.nextQuestionButtonText ? initData.nextQuestionButtonText : 'Следующий вопрос';
            state.resultsButtonText = initData.resultsButtonText ? initData.resultsButtonText : 'Результаты';
            state.quizName = initData.quizName ? initData.quizName : '';
            state.initImgDesc = initData.initImgDesc ? initData.initImgDesc : '';
        },
        timerStart: function( state ) {
          state.timer = setInterval(function(){
              state.timerValue ++;
          },1000);
        },
        timerStop: function ( state ) {
            clearInterval(state.timer);
        },
        timerReset: function ( state ) {
            state.timerValue = 0;
        },
    },
    actions: {
        name : function(context, data) {
            context.commit('name'); // name = имя мутации, которая должна быть выполнена
        },
    }
});
